import MenuCM from "components/shared/menu";
import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import ContactCM from "components/contactus";
import { StyledIcondiv, StatusMain } from "./Payment.style";
import { Container } from "@mui/material";
import FooterCM from "components/shared/footer";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {Helmet} from "react-helmet";

export default function PaymentStatus() {
  const params = useParams();
  return (
    <>
      <Box
        style={{
          marginBottom: "50px",
          marginTop: "70px",
        }}
      >
        <>
          <Helmet>
            <title>سفارش موفق - مبلمان ویول</title>
            <meta name="product_id" content={""} />
            <meta name="product_name" content={""} />
            <meta name="product_price" content={""} />
            <meta name="product_old_price" content={""} />
            <meta name="availability" content={""} />
            <meta property="og:image" content={""} />
          </Helmet>
          <MenuCM Background pageTitle="وضعیت پرداخت" />
          <Container>
            <StatusMain>
              <StyledIcondiv>
                <CheckCircleOutlineIcon style={{ color: "green" }} />
              </StyledIcondiv>
              <p>پرداخت با موفقیت انجام شد</p>
              <p>
                <span>شماره سفارش : </span>
                <span>{params.statusId}</span>
              </p>
            </StatusMain>
          </Container>
          <ContactCM All />
          <FooterCM />
        </>
      </Box>
    </>
  );
}
